// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/katlin/Coding/portfolio/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/home/katlin/Coding/portfolio/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("/home/katlin/Coding/portfolio/src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("/home/katlin/Coding/portfolio/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-shoutbase-js": () => import("/home/katlin/Coding/portfolio/src/pages/shoutbase.js" /* webpackChunkName: "component---src-pages-shoutbase-js" */),
  "component---src-pages-work-js": () => import("/home/katlin/Coding/portfolio/src/pages/work.js" /* webpackChunkName: "component---src-pages-work-js" */)
}

